<template>
  <el-card class="box-card payment">
    <el-tabs v-model="active" @tab-click="tabClick">
      <el-tab-pane label="Payment Info" name="payment-info" class="payment-info">
        <el-form v-loading="edit_loading" ref="paymenInfo" :model="payment_new" :rules="formRules">
          <div class="form-group form-light">
            <label class="label">
              Payment Type
              <i v-if="payment_info_edit" class="required-mark">*</i>
            </label>
            <label class="label value" v-if="!payment_info_edit">
              {{ pay_type_name }}
            </label>
            <div class="form-control radio-group" v-else>
              <el-form-item prop="pay_type">
                <el-radio-group v-model="payment_new.pay_type">
                  <el-radio :label="1">Bank</el-radio>
                  <el-radio :label="0">Paypal</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
          </div>
          <div class="form-group form-light">
            <label class="label">
              Company/ Beneficiary's Name
              <i v-if="payment_info_edit" class="required-mark">*</i>
            </label>
            <label class="label value">{{ settings.user.company || '--' }}</label>
            <label class="label tips">
              <i class="required-mark">*&nbsp;</i>
              The name should be the same with Company/Name.
            </label>
          </div>
          <div class="form-group form-light">
            <label class="label">
              Account Number
              <i v-if="payment_info_edit" class="required-mark">*</i>
            </label>
            <label class="label value" v-if="!payment_info_edit">
              {{ payment_info.account || '--' }}
            </label>
            <el-form-item class="form-control" prop="account" v-else>
              <el-input v-model="payment_new.account"></el-input>
            </el-form-item>
          </div>
          <div class="form-group form-light">
            <label class="label">
              Currency
              <i v-if="payment_info_edit" class="required-mark">*</i>
            </label>
            <label class="label value" v-if="!payment_info_edit">
              {{ payment_info.currency == 1 ? 'RMB(￥)' : 'Dollar($)' }}
            </label>
            <div class="form-control radio-group" v-else>
              <el-form-item prop="currency">
                <el-radio-group v-model="payment_new.currency">
                  <el-radio :label="1">RMB(￥)</el-radio>
                  <el-radio :label="2">Dollar($)</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
          </div>
          <div class="form-group form-light" v-if="isBank()">
            <label class="label">
              Country
              <i v-if="payment_info_edit" class="required-mark">*</i>
            </label>
            <label class="label value" v-if="!payment_info_edit">
              {{ `${payment_info.country_code}-${payment_info.country_name}` }}
            </label>
            <div class="form-control" v-else>
              <el-form-item prop="country">
                <el-select
                  v-model="payment_new.country"
                  value-key="code"
                  placeholder="Country"
                  filterable
                >
                  <el-option
                    v-for="item in country"
                    :key="item.code"
                    :label="item.code_name"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
          <div class="form-group form-light" v-if="isBank()">
            <label class="label">
              Bank Name
              <i v-if="payment_info_edit" class="required-mark">*</i>
            </label>
            <label class="label value" v-if="!payment_info_edit">
              {{ payment_info.bank_name || '--' }}
            </label>
            <el-form-item class="form-control" prop="bank_name" v-else>
              <el-input v-model="payment_new.bank_name"></el-input>
            </el-form-item>
          </div>
          <div class="form-group form-light" v-if="isBank()">
            <label class="label">
              Bank Address
              <i v-if="payment_info_edit" class="required-mark">*</i>
            </label>
            <label class="label value" v-if="!payment_info_edit">
              {{ payment_info.bank_address || '--' }}
            </label>
            <el-form-item class="form-control" prop="bank_address" v-else>
              <el-input v-model="payment_new.bank_address"></el-input>
            </el-form-item>
          </div>
          <div class="form-group form-light" v-if="isBank()">
            <label class="label">
              SWIFT CODE
              <i v-if="payment_info_edit" class="required-mark">*</i>
            </label>
            <label class="label value" v-if="!payment_info_edit">
              {{ payment_info.bank_swift || '--' }}
            </label>
            <el-form-item class="form-control" prop="bank_swift" v-else>
              <el-input v-model="payment_new.bank_swift"></el-input>
            </el-form-item>
          </div>

          <div class="form-group form-light height mt-4">
            <label class="label">
              Signature
              <i v-if="payment_info_edit" class="required-mark">*</i>
            </label>
            <el-form-item prop="signature_file" v-if="payment_new.signature">
              <el-upload
                action=""
                :auto-upload="false"
                class="avatar-uploader ml-4"
                :show-file-list="false"
                :on-change="uploadSignature"
              >
                <img :src="payment_new.signature" class="sign-preview" />
              </el-upload>
            </el-form-item>
            <label class="label value" v-else>--</label>

            <div class="demo">
              <el-tooltip
                effect="light"
                placement="top"
                enterable
                :visible-arrow="false"
                popper-class="img-tooltip"
              >
                <div slot="content">
                  <img src="../../assets/img/signature.png" class="sign-preview" />
                </div>
                <a>Example Of Signature</a>
              </el-tooltip>
            </div>
          </div>

          <div class="note">
            <p>
              <i class="required-mark">*</i>
              Please Note:
            </p>
            <p>The signature supports jpg/png, white background, 180*100</p>
            <p>The signature is only used for invoice of your payment</p>
            <p>The signature must be consistent with the beneficiary's name</p>
          </div>

          <div class="mt-8 center">
            <div v-if="!payment_info_edit">
              <el-tooltip
                enterable
                :visible-arrow="false"
                content="The account is under review and cannot be modified"
                placement="top"
                :disabled="payment_info.edit != 0"
                popper-class="tooltip_popper"
              >
                <span>
                  <el-button
                    type="primary"
                    @click="editPaymentInfo()"
                    :disabled="payment_info.edit == 0"
                  >
                    Edit
                  </el-button>
                </span>
              </el-tooltip>

              <el-button
                type="primary"
                @click="editPaymentInfo()"
                :disabled="payment_info.edit == 0"
                v-if="!payment_info"
              >
                Create
              </el-button>
            </div>
            <div v-else>
              <el-button type="primary" @click="savePaymentInfo()">Save</el-button>
              <el-button type="danger" @click="canceEditPaymentInfo()">Cancel</el-button>
            </div>
          </div>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="Modification History" name="modify-history" class="modify-history">
        <el-table v-loading="modi_loading" :fit="true" ref="refTable" border :data="modify_list">
          <el-table-column type="expand">
            <template slot-scope="scope">
              <el-row type="flex" justify="space-between">
                <el-col :span="11">
                  <h3>Before</h3>
                  <table class="table table-bordered table-reversal">
                    <tbody>
                      <tr>
                        <td>Payment Type</td>
                        <td>{{ scope.row.origin_pay_type == 1 ? 'Bank' : 'Paypal' }}</td>
                      </tr>
                      <tr>
                        <td>Beneficiary's Name</td>
                        <td>{{ scope.row.origin_beneficiary }}</td>
                      </tr>
                      <tr>
                        <td>Account Number</td>
                        <td>{{ scope.row.origin_account }}</td>
                      </tr>
                      <tr>
                        <td>Currency</td>
                        <td>{{ scope.row.origin_currency == 1 ? 'RMB(￥)' : 'Dollar($)' }}</td>
                      </tr>
                      <tr v-if="scope.row.origin_pay_type == 1">
                        <td>Country</td>
                        <td>{{ scope.row.origin_country }}</td>
                      </tr>
                      <tr v-if="scope.row.origin_pay_type == 1">
                        <td>Bank Name</td>
                        <td>{{ scope.row.origin_bank_name }}</td>
                      </tr>
                      <tr v-if="scope.row.origin_pay_type == 1">
                        <td>Bank Address</td>
                        <td>{{ scope.row.origin_bank_address }}</td>
                      </tr>
                      <tr v-if="scope.row.origin_pay_type == 1">
                        <td>SWIFT CODE</td>
                        <td>{{ scope.row.origin_bank_swift }}</td>
                      </tr>
                      <tr>
                        <td>Signature</td>
                        <td>
                          <img class="sign-preview" :src="scope.row.origin_signature_filepath" />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </el-col>

                <el-col :span="11">
                  <h3>After</h3>
                  <table class="table table-bordered table-reversal">
                    <tbody>
                      <tr>
                        <td>Payment Type</td>
                        <td>{{ scope.row.new_pay_type == '1' ? 'Bank' : 'Paypal' }}</td>
                      </tr>
                      <tr>
                        <td>Beneficiary's Name</td>
                        <td>{{ scope.row.new_beneficiary }}</td>
                      </tr>
                      <tr>
                        <td>Account Number</td>
                        <td>{{ scope.row.new_account }}</td>
                      </tr>
                      <tr>
                        <td>Currency</td>
                        <td>{{ scope.row.new_currency == 1 ? 'RMB(￥)' : 'Dollar($)' }}</td>
                      </tr>
                      <tr v-if="scope.row.new_pay_type == 1">
                        <td>Country</td>
                        <td>{{ scope.row.new_country }}</td>
                      </tr>
                      <tr v-if="scope.row.new_pay_type == 1">
                        <td>Bank Name</td>
                        <td>{{ scope.row.new_bank_name }}</td>
                      </tr>
                      <tr v-if="scope.row.new_pay_type == 1">
                        <td>Bank Address</td>
                        <td>{{ scope.row.new_bank_address }}</td>
                      </tr>
                      <tr v-if="scope.row.new_pay_type == 1">
                        <td>SWIFT CODE</td>
                        <td>{{ scope.row.new_bank_swift }}</td>
                      </tr>
                      <tr>
                        <td>Signature :</td>
                        <td>
                          <img class="sign-preview" :src="scope.row.new_signature_filepath" />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </el-col>
              </el-row>
            </template>
          </el-table-column>

          <el-table-column prop="update_time" label="Date" min-width="130px"></el-table-column>

          <el-table-column
            prop="origin_beneficiary"
            label="Before Modification"
            min-width="130px"
          ></el-table-column>

          <el-table-column
            prop="new_beneficiary"
            label="Modification"
            min-width="130px"
          ></el-table-column>

          <el-table-column
            prop="approved"
            label="Approved Manager"
            min-width="130px"
          ></el-table-column>

          <el-table-column label="Status">
            <template slot-scope="scope">
              <span class="label" :class="status_list[scope.row.status]">
                {{ status_list[scope.row.status] }}
              </span>
            </template>
          </el-table-column>
        </el-table>
        <pagination
          :page="page"
          @sizeChange="getModifyList()"
          @currentChange="getModifyList()"
        ></pagination>
      </el-tab-pane>
      <el-tab-pane label="Payment History" name="payment-history">
        <el-row type="flex" :gutter="20" align="center">
          <el-col :span="6">
            <label class="ym-label">Status</label>
            <el-select v-model="history_params.status" placeholder="Status" :clearable="true">
              <el-option
                v-for="item in payment_status_list"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-col>

          <el-col :span="6">
            <label class="ym-label">Search</label>
            <el-input
              v-model="history_params.search"
              placeholder="Search"
              @keyup.enter.native="getPaymentHistory()"
            ></el-input>
          </el-col>

          <el-col :span="8">
            <label class="ym-label">Range</label>
            <el-date-picker
              v-model="history_params.date"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="daterange"
              range-separator="to"
              start-placeholder="Start"
              end-placeholder="End"
            ></el-date-picker>
          </el-col>

          <el-col :span="3" class="filter-run">
            <el-button type="primary" @click="getPaymentHistory()">Run</el-button>
          </el-col>
        </el-row>

        <el-table border :data="history_list" v-loading="pay_loading">
          <el-table-column
            prop="invoice_id"
            label="Invoice No."
            min-width="130px"
          ></el-table-column>

          <el-table-column prop="create_date" label="Date" min-width="100px"></el-table-column>

          <el-table-column label="Period" min-width="200px">
            <template slot-scope="scope">
              {{ scope.row.start_date }} to {{ scope.row.end_date }}
            </template>
          </el-table-column>

          <el-table-column
            prop="payment_type"
            label="Payment Type"
            min-width="120px"
          ></el-table-column>

          <el-table-column
            prop="beneficiary_name"
            label="Beneficiary"
            min-width="120px"
          ></el-table-column>

          <el-table-column prop="account" label="IBAN" min-width="150px"></el-table-column>

          <el-table-column
            prop="conversions"
            label="Conversion"
            min-width="100px"
          ></el-table-column>

          <el-table-column label="Amout" min-width="100px">
            <template slot-scope="scope">
              {{ '$ ' + scope.row.amount.toFixed(2) }}
            </template>
          </el-table-column>

          <el-table-column label="Status">
            <template slot-scope="scope">
              <span
                class="label"
                :class="
                  scope.row.status == 'Paid'
                    ? 'success'
                    : scope.row.status == 'Rejected'
                    ? 'error'
                    : 'gray'
                "
              >
                {{ scope.row.status }}
              </span>
            </template>
          </el-table-column>

          <el-table-column label="Bank Slip" min-width="120px">
            <template slot-scope="scope">
              <a target="_blank" v-if="scope.row.bank_slip.length" :href="scope.row.bank_slip">
                {{ scope.row.bank_slip_name }}
              </a>
              <span v-else>Not Uploaded</span>
            </template>
          </el-table-column>
        </el-table>

        <pagination
          :page="h_page"
          @sizeChange="getPaymentHistory()"
          @currentChange="getPaymentHistory()"
        ></pagination>
      </el-tab-pane>
    </el-tabs>
  </el-card>
</template>

<script>
import { mapState } from 'vuex'
import pagination from '../../components/pagination.vue'
import { pageMixin } from '../../mixins/commonMixin'

export default {
  mixins: [pageMixin],
  computed: {
    ...mapState(['settings', 'country']),
    formRules() {
      let props = [
        {
          name: 'account',
          max: 128,
        },
        {
          name: 'bank_name',
          max: 128,
        },
        {
          name: 'bank_address',
          max: 256,
        },
        {
          name: 'bank_swift',
          max: 128,
        },
      ]
      let rules = {}
      let commonRule = [{ required: true, message: 'Can\'t be empty!', trigger: 'change' }]
      for (let value of props) {
        rules[value.name] = [
          {
            required: true,
            max: value.max,
            trigger: ['blur', 'change'],
            message: 'Can\'t be empty!',
          },
        ]
      }
      rules['signature_file'] = [
        {
          validator: (rule, value, callback) => {
            if (!(this.payment_new.signature_file || this.payment_new.signature)) {
              callback(new Error('Can\'t be empty!'))
            } else {
              callback()
            }
          },
          trigger: 'change',
        },
      ]

      rules['currency'] = commonRule
      rules['country'] = commonRule
      rules['pay_type'] = commonRule
      return rules
    },
  },
  components: {
    pagination,
  },
  data() {
    return {
      active: 'payment-info',
      edit_loading: false,
      modi_loading: false,
      pay_loading: false,
      user_id: '',
      payment_info: {
        pay_type: 0,
      },
      payment_new: {},
      payment_info_edit: false,

      modify_list: [],
      status_list: {
        0: 'Pending',
        1: 'Active',
        2: 'Cancel',
        3: 'Waiting',
        4: 'Rejected',
      },
      payment_status_list: [
        { id: 1, name: 'Pending' },
        { id: 2, name: 'Paid' },
        { id: 3, name: 'Rejected' },
      ],
      h_page: {
        tot: 25,
        cur: 1,
        per: 25,
      },
      history_params: {
        status: '',
        search: '',
        date: ['2000-01-01 00:00:00', '2019-01-16 23:59:59'],
      },
      history_list: [],
      pay_type_name: '',
    }
  },
  created() {
    this.$store.dispatch('getCountry')
    this.$store.dispatch('getPerm').then(() => {
      this.user_id = this.settings.user.id
      this.getInfo()
    })
    this.getModifyList()
    this.getPaymentHistory()
  },
  methods: {
    getInfo() {
      this.$http
        .get('/api/aff/get-pay-info-list/', {
          params: {
            aff_id: this.user_id,
          },
        })
        .then(res => {
          if (res.length) {
            this.payment_info = res[0]
            this.payment_info.country = this.payment_info.country_code
            if (this.payment_info.pay_type === 1) {
              this.pay_type_name = 'Bank'
            } else if (this.payment_info.pay_type === 2) {
              this.pay_type_name = 'Payoneer'
            } else {
              this.pay_type_name = 'Paypal'
            }
            this.payment_new = { ...this.payment_info }
          }
        })
    },
    isBank() {
      return (
        (this.payment_info_edit && this.payment_new.pay_type === 1) ||
        (!this.payment_info_edit && this.payment_info.pay_type === 1)
      )
    },
    tabClick(tab) {
      if (tab.name === 'modify-history') {
        this.getModifyList()
      }
    },
    editPaymentInfo() {
      this.updateInfo(this.$route.path, true)
    },
    canceEditPaymentInfo() {
      this.payment_info_edit = false
    },
    savePaymentInfo() {
      if (!this.isFormValid('paymenInfo')) {
        return
      }

      let payment_new = this.payment_new
      if (!(payment_new.signature_file || payment_new.signature)) {
        return
      }

      let { country_code, country_name, signature_file, ...params } = { ...payment_new }

      this.edit_loading = true
      this.$http
        .post('/api/aff/edit-pay-info/', {
          ...params,
          files: true,
          aff_id: this.user_id,
          signature: payment_new.signature_file || payment_new.signature,
        })
        .then(() => {
          this.edit_loading = false
          this.notifyOpen()
          // this.payment_info = {...payment_new};
          // let payment_info = this.payment_info;
          // payment_info.signature = res.signature;
          this.payment_info_edit = false
          this.getInfo()
        })
        .catch(err => {
          this.edit_loading = false
          this.notifyOpen('Error', this.executeError(err), 'error')
        })
    },
    uploadSignature(file) {
      this.payment_new.signature_file = file.raw
      let reader = new FileReader()
      reader.readAsDataURL(file.raw)
      reader.onload = load => {
        this.$set(this.payment_new, 'signature', load.currentTarget.result)
      }
    },

    getModifyList() {
      this.modi_loading = true
      this.$http
        .get('/api/aff/get-pay-info-apply-list/', {
          params: {
            p: this.page ? this.page.cur : 1,
            n: this.page ? this.page.per : 10,
          },
        })
        .then(res => {
          this.modi_loading = false
          this.modify_list = res.data
          this.changePageItem(this.page, res)
        })
        .catch(err => {
          this.modi_loading = false
          this.notifyOpen('Error', this.executeError(err), 'error')
        })
    },

    cancelApply(obj) {
      this.$http
        .post('/api/aff/set-pay-info-apply/', {
          id: obj.id,
          aff_id: this.user_id,
          status: 2,
        })
        .then(() => {
          obj.status = 2
          this.notifyOpen()
          this.getInfo()
        })
        .catch(err => {
          this.notifyOpen('Error', this.executeError(err), 'error')
        })
    },

    getPaymentHistory() {
      let params = this.history_params
      this.pay_loading = true
      this.$http
        .get('/api/aff/get-payment-history-list/', {
          params: {
            p: this.page ? this.page.cur : 1,
            n: this.page ? this.page.per : 10,
            status: params.status - 1,
            search: params.search,
            date_start: params.date[0],
            date_end: params.date[1],
          },
        })
        .then(res => {
          this.pay_loading = false
          this.history_list = res.data
          this.changePageItem(this.h_page, res)
        })
        .catch(err => {
          this.pay_loading = false
          this.notifyOpen('Error', this.executeError(err), 'error')
        })
    },
  },
}
</script>
<style lang="scss">
.payment {
  .center {
    text-align: center;
  }
  .form-group {
    height: 32px;
    margin-bottom: 10px;
  }
  .radio-group {
    align-items: center;
    display: inline-flex;
    .el-form-item {
      margin-bottom: 0;
    }
  }
  .payment-info {
    .form-group .label {
      width: 145px;
    }
  }
  .form-control {
    width: 250px;
  }
  .note {
    margin-left: 80px;
    margin-top: 23px;
    color: #9b9ea3;
    font-size: 12px;
    line-height: 18px;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    height: 100px;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    background-color: #f6f8fb;
    width: 180px;
    height: 100px;
    text-align: center;
    line-height: 100px;
  }
  .demo {
    margin-left: 132px;
    display: inline-flex;
    align-items: center;
  }
  .el-tabs__content {
    position: static;
  }
}
.sign-preview {
  width: 180px;
  height: 100px;
  border: 1px solid #eee;
}
.el-tooltip__popper.is-light.img-tooltip {
  border: 0;
  padding: 0;
}
</style>
